import { chakra, forwardRef } from '@chakra-ui/system';
import type { HTMLChakraProps } from '@chakra-ui/system';
import { cx } from '@chakra-ui/utils';
import type { PropsWithChildren } from 'react';

import { useContainerStyles } from './';
import { getClassName } from './className';

export type ContainerTitleProps = PropsWithChildren<unknown> &
  HTMLChakraProps<'div'>;

export const ContainerTitle = forwardRef<ContainerTitleProps, 'div'>(
  ({ children, className, ...props }: ContainerTitleProps, ref) => {
    const styles = useContainerStyles() ?? {};

    return (
      <chakra.h2
        ref={ref}
        sx={styles.containerTitle}
        className={cx(getClassName('title'), className)}
        {...props}
      >
        {children}
      </chakra.h2>
    );
  },
);
ContainerTitle.displayName = 'ContainerTitle';
